import { call, put, takeEvery } from "redux-saga/effects";
import { USER } from "./actionTypes";
import { getDropDownUser, getListaUser, getUser, saveUser } from "./actions";
import moment from "moment";
import { emptyStringToNull } from "../../helpers/null_empty_string_helper";
import { USER_URL } from "../../helpers/url_api_helper";
import { normalizeApiError } from "../../helpers/utils/normalizeApiError";

function* listarUser({ payload }) {
  const filterUser = payload;
  try {
    emptyStringToNull(filterUser);
    const res = yield call(USER_URL.getUserLista, filterUser);
    yield put(getListaUser.success(res));
  } catch (error) {
    yield put(
      getListaUser.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the system's users, please try again later"
        )
      )
    );
  }
}

function* listarDropDownUser() {
  try {
    const res = yield call(USER_URL.getUserDropDown);
    yield put(getDropDownUser.success(res));
  } catch (error) {
    yield put(
      getDropDownUser.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the system's users, please try again later"
        )
      )
    );
  }
}

function* obterUser({ payload }) {
  const { userId } = payload;
  try {
    const res = yield call(USER_URL.getUser, userId);
    res.record.activeStatus =
      res.record.active === true ? ["Active Status"] : [];
    res.record.createDate = moment(res.record.createDate)
      .format("DD MMM/YY hh:mm A")
      .toString();
    res.record.updateDate =
      res.record.updateDate !== null
        ? moment(res.record.updateDate).format("DD MMM/YY hh:mm A").toString()
        : "";
    yield put(getUser.success(res));
  } catch (error) {
    yield put(
      getUser.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the system user, please try again later"
        )
      )
    );
  }
}

function* salvarUser({ payload }) {
  const { body, type } = payload;
  try {
    if (type === "POST") {
      yield call(USER_URL.postUser, body);
      yield put(saveUser.success(true));
    } else {
      yield call(USER_URL.putUser, body);
      yield put(saveUser.success(true));
    }
  } catch (error) {
    yield put(
      saveUser.fail(
        normalizeApiError(
          error,
          "Something went wrong saving the system user, please try again later"
        )
      )
    );
  }
}

function* UserSaga() {
  yield takeEvery(USER.GET_LISTA_USER.REQUEST, listarUser);
  yield takeEvery(USER.GET_DROPDOWN_USER.REQUEST, listarDropDownUser);
  yield takeEvery(USER.GET_USER.REQUEST, obterUser);
  yield takeEvery(USER.SAVE_USER.REQUEST, salvarUser);
}

export default UserSaga;
